class Player {
    constructor(player){
        this.player = player;
    }

    showTitle(status){
        return this.player.showTitle(status);
    }

    showControls(status){
        return this.player.showControls(status);
    }

    mute(){
        return this.player.mute();
    }

    unMute(){
        return this.player.unMute();
    }

    play(){
        return this.player.play();
    }

    stop(){
        return this.player.stop();
    }

    source(source){
        return this.player.source(source);
    }
}

export default Player;